import { render, staticRenderFns } from "./UserAssignmentsDropDownList.vue?vue&type=template&id=297da863"
import script from "./UserAssignmentsDropDownList.vue?vue&type=script&lang=js"
export * from "./UserAssignmentsDropDownList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports